"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var atoms_1 = require("../../styles/atoms");
var selectors_1 = require("../selectors");
var Faq = function () {
    var faq = (0, react_redux_1.useSelector)(selectors_1.faqSelector);
    return (react_1.default.createElement(atoms_1.Div, { visible: !!faq.length, className: "faq" },
        react_1.default.createElement("h2", { className: "faq__title" }, "FAQ"),
        react_1.default.createElement("div", { className: "faq__list" }, faq.map(function (item, i) { return (react_1.default.createElement(FaqItem, { key: i, data: item, isOpenInitial: false })); }))));
};
var FaqItem = function (props) {
    var data = props.data, isOpenInitial = props.isOpenInitial;
    var _a = (0, react_1.useState)(isOpenInitial), isOpen = _a[0], setIsOpen = _a[1];
    var toggleAnswer = function () { return setIsOpen(!isOpen); };
    return (react_1.default.createElement("div", { className: "faq__item" },
        react_1.default.createElement("div", { className: "faq-question", onClick: toggleAnswer }, data.question),
        react_1.default.createElement(atoms_1.Div, { visible: isOpen, className: "faq-answer" }, data.answer)));
};
exports.default = Faq;
